import { collectionEngineV1 } from '../apis.js';
const documentsV1API = collectionEngineV1('/documents');
export const add = (entityId, type, entityType, file, isSigned, signedAt, date, minAccessRole, meta) => documentsV1API('POST', `/`, {
    body: {
        entityId,
        type,
        file,
        isSigned,
        signedAt,
        date,
        minAccessRole,
        meta,
        entityType,
    },
});
export const get = (entityId, casualConsistency) => documentsV1API('GET', `/${entityId}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const getLimitation = (caseId) => documentsV1API('GET', `/limitation/${caseId}`);
export const update = (documentId, document) => documentsV1API('PATCH', '/' + documentId, {
    body: document,
});
export const del = (documentId) => documentsV1API('DELETE', '/' + documentId);
export const getLinkToSignDocument = async (documentId, role, name, successURL) => documentsV1API('GET', `/get-signing-link/${encode(documentId)}/${encode(role)}/${encode(name)}?successURL=${successURL ? encode(successURL) : ''}`);
const encode = (s) => encodeURIComponent(encodeURIComponent(s));
export const getSigningLink = (caseId, handle, signedURL, declinedSigningURL) => documentsV1API('POST', `/${caseId}/get-signing-link/${handle}?signedURL=${encodeURIComponent(signedURL)}&declinedSigningURL=${encodeURIComponent(declinedSigningURL)}`);
//# sourceMappingURL=documents.js.map